export const DEFAULT_REFETCH_INTERVAL = 60000
export const FAST_REFETCH_INTERVAL = 10000
export const BALANCE_REFETCH_INTERVAL = 3000
